import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { EMPTY, Observable, timer, Subscription, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { HttpService } from '../../core/services/http.service';
import {
  Keys,
  PersistenceService
} from '../../core/services/persistence.service';
import { TokenService } from '../../core/services/token.service';
import { SessionModalComponent } from '../../shared/components/modals/session-modal/session-modal.component';
import { AuthResponse } from '../models/auth.response';
import { LoginRequest } from '../models/login.request';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isAuthenticate = false;
  timeToExpire: number;
  subcription: Subscription;
  timerSubscription: Subscription;

  constructor(
    private persistence: PersistenceService,
    private router: Router,
    private modalService: NgbModal,
    private tokenService: TokenService,
    private config: NgbModalConfig,
    private httpService: HttpService,
    private ngbModal: NgbModal
  ) {
    this.isAuthenticate = JSON.parse(
      this.persistence.getValue(Keys.isAuthenticate)
    );
    this.config.backdrop = 'static';
    this.config.keyboard = false;
  }

  login(payload: LoginRequest): Observable<AuthResponse> {
    const api = `${environment.host}api/v1/auth/login`;
    this.httpService.uri = api;
    return this.httpService.execPostJson(payload).pipe(
      tap(({ data }) => {
        if (data) {
          this.setSession(data.token);
        }
      }),
      catchError(error => {
        console.log('error', error);
        return EMPTY;
      })
    );
  }

  verifyCredential(payload: LoginRequest): Observable<any> {
    const api = `${environment.host}api/v1/auth/login`;
    this.httpService.uri = api;
    return this.httpService.execPostJson(payload).pipe(
      catchError(error => {
        console.log('error', error);
        return EMPTY;
      })
    );
  }

  autoLogin(access_token: string): Observable<AuthResponse> {
    const api = `${environment.host}api/v1/auth/auto-login`;
    this.httpService.uri = api;
    return this.httpService.execPostJson({ access_token }).pipe(
      catchError(error => {
        console.log('error', error);
        return EMPTY;
      }),
      tap(data => {
        if (data.cause && data.cause === 'INVALID_CREDENTIALS') {
          return throwError(data.cause);
        } else {
          this.setSession(data.data.token);
        }
      })
    );
  }

  recoveryAccount(email: string): Observable<any> {
    const api = `${environment.host}ms-user/api/v1/user/forget-password`;
    this.httpService.uri = api;
    return this.httpService.execPostJson({ email });
  }

  setSession(token: string) {
    // TODO: agregar el tiempo de expiracion
    this.isAuthenticate = true;
    this.persistence.addValue(Keys.accessToken, token);
    this.persistence.addValue(
      Keys.isAuthenticate,
      JSON.stringify(this.isAuthenticate)
    );
    this.createIntervalModal();
    this.createIntervalLogout();
  }

  private createIntervalModal() {
    const timeToRemenber = this.tokenService.timeToAlert();
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.timerSubscription = timer(timeToRemenber).subscribe({
      next: () => this.openModalRefresh(timeToRemenber)
    });
  }

  private createIntervalLogout() {
    if (this.subcription) {
      this.subcription.unsubscribe();
    }
    this.subcription = this.tokenService
      .remainToExpire()
      .subscribe(timeToExpire => {
        this.timeToExpire = timeToExpire;
        if (this.timeToExpire < 1 && this.isAuthenticate) {
          this.cleanSession();
        }
      });
  }

  cleanSession() {
    if (this.ngbModal.hasOpenModals) {
      this.ngbModal.dismissAll();
    }
    if (this.subcription) {
      this.subcription.unsubscribe();
    }
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.isAuthenticate = false;
    this.persistence.clear();
    this.router.navigateByUrl('login');
  }

  logout() {
    const api = `${environment.host}api/v1/auth/logout`;
    this.httpService.uri = api;
    return this.httpService
      .execPostJson()
      .pipe(
        tap(response => {
          if (response.status === 200) {
            this.cleanSession();
          }
        }),
        catchError(error => {
          console.log('error', error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  refreshToken() {
    const api = `${environment.host}api/v1/auth/refresh-token`;
    this.httpService.uri = api;
    this.httpService
      .execPostJson({})
      .pipe(
        tap(({ data }) => {
          if (data) {
            this.setSession(data.token);
          }
        })
      )
      .subscribe();
  }

  openModalRefresh(timeToRemenber: number) {
    if (!this.ngbModal.hasOpenModals()) {
      this.modalService
        .open(SessionModalComponent, { centered: true })
        .result.then(
          result => {
            this.refreshToken();
          },
          reason => {}
        );
    }
  }
}
